import { DialogContent } from "@mui/material";
import {
  BottomSheet,
  BottomSheetLoadingContent,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";
import { getSafeAreaPaddings } from "@src/appV2/redesign/system/ui-theme";
import { useCallback } from "react";

import { BottomSheetHeader } from "../../components/BottomSheetHeader";

interface DocumentSubmissionInProgressBottomSheetProps {
  modalState: UseModalState;
}

export function DocumentSubmissionInProgressBottomSheet(
  props: DocumentSubmissionInProgressBottomSheetProps
) {
  const { modalState } = props;

  const handleClose = useCallback(() => {
    modalState.closeModal();
  }, [modalState]);

  return (
    <BottomSheet
      header={<BottomSheetHeader onClose={handleClose} />}
      modalState={modalState}
      paperSx={{
        ...getSafeAreaPaddings({ bottom: true }),
      }}
    >
      <DialogContent sx={{ paddingX: 5 }}>
        <BottomSheetLoadingContent
          title="Submitting Document"
          description="Should only take a few seconds"
        />
      </DialogContent>
    </BottomSheet>
  );
}
